import { VenueOperatorType } from '@api';
import {
  EmailAnchor,
  getValueByPath,
  PhoneNumberAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
  useFormatAddress,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueOperatorTableRowType } from '../../types';

type VenueOperatorTableRowPropsType = {
  venueOperator: VenueOperatorType;
  row: VenueOperatorTableRowType;
};

export const VenueOperatorTableRow: React.FC<
  VenueOperatorTableRowPropsType
> = ({ venueOperator, row }) => {
  const { t } = useTranslation('venueDetailsGeneral');
  const { formatAddressMultiLine } = useFormatAddress();

  const getRenderValue = () => {
    const value = getValueByPath(venueOperator, row.accessor);

    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'address':
        return formatAddressMultiLine(venueOperator.address);
      case 'contact.phone':
      case 'contact.mobile':
      case 'contact.fax':
        return <PhoneNumberAnchor phoneNumber={String(value)} />;
      case 'contact.email':
        return <EmailAnchor email={String(value)} />;
      default:
        return String(value);
    }
  };

  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>
        {t(`VENUE_OPERATOR.ROWS.${row.label}`)}
      </TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
